import React, { useCallback, useEffect, useState } from "react";

import { real_date } from "../../../services/convert/date";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_service_requests } from "../../../services/apis/requests";
// import { get_service_requests } from "../../../services/apis/requests";

const Request = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ request }) => request.loading);
  const requests = useAppSelector(({ request }) => request.requests);
  const [currentPage, setCurrentPage] = useState(1);

  const onLoad = useCallback(() => {
    get_service_requests(dispatch, currentPage);
  }, [dispatch, currentPage]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  const getStatusColor = (statusId: string) => {
    switch (statusId?.toLowerCase()) {
      case "pending":
        return "bg-yellow-100 text-yellow-800";
      case "approved":
      case "completed":
        return "bg-green-100 text-green-800";
      case "processing":
        return "bg-blue-100 text-blue-800";
      case "rejected":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div>
      <h4 className="text-left text-[17px] font-bold mb-3">Service Request</h4>

      {loading ? (
        <div className="bg-white rounded-xl shadow-md flex justify-center items-center h-[200px]">
          <span>Loading...</span>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200 bg-muted/30">
                <th className="px-6 py-3 text-left text-sm font-semibold text-foreground">
                  SN
                </th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-foreground">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-foreground">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-foreground">
                  Date
                </th>
              </tr>
            </thead>
            <tbody className="w-full p-4 space-y-4">
              {requests &&
                requests.slice(0, 5).map((item, index) => (
                  <tr
                    key={item.id}
                    className="border-b border-gray-100 hover:bg-muted/50 transition-colors"
                  >
                    <td className="px-6 py-3">{index + 1}</td>
                    <td className="px-6 py-3">
                      <span className="text-sm font-medium text-foreground">
                        {item.service?.name ||
                          item?.document?.name ||
                          "Untitled"}
                      </span>
                    </td>
                    <td className="px-6 py-3">
                      <span
                        className={`text-xs font-medium rounded-full px-2 py-1 ${getStatusColor(item.request_status?.id || "")}`}
                      >
                        {item.request_status?.name ||
                          item.request_status?.id ||
                          "Unknown"}
                      </span>
                    </td>
                    <td className="px-6 py-3">
                      <span className="text-sm text-muted-foreground">
                        {real_date(item.created_at)}
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div className="flex justify-end gap-2 p-3">
            <button
              className="w-20 bg-gray-100/50 py-1 rounded-md"
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            >
              Previous
            </button>
            <button
              className="w-20 bg-gray-100/50 py-1 rounded-md"
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Request;
